import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { useAuth } from '../contexts/AuthContext';
import { getActivePromotion } from '../services/api';
import PhoneVerification from './user/PhoneVerification';

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

const sanitizePromoHtml = (html) =>
  DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['a', 'b', 'strong', 'i', 'em', 'u', 'br', 'p', 'ul', 'ol', 'li', 'span', 'img'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'src', 'alt', 'style'],
  });

const PromoPage = () => {
  const { merchantSlug } = useParams();
  const navigate = useNavigate();
  const { user, updateUser } = useAuth();
  const [promo, setPromo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!merchantSlug) return;
    let cancelled = false;
    getActivePromotion(merchantSlug)
      .then((res) => {
        if (!cancelled) setPromo(res.data);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [merchantSlug]);

  return (
    <div className="max-w-md mx-auto px-4 py-8 min-h-screen pb-24">
      <button
        onClick={() => navigate(`/${merchantSlug}`)}
        className="text-sm font-bold text-gray-400 mb-6"
      >
        ← 返回
      </button>

      {loading && <p className="text-center text-gray-400">載入中...</p>}

      {!loading && !promo && (
        <p className="text-center text-gray-400">暫時未有進行中嘅優惠活動</p>
      )}

      {!loading && promo && (
        <>
          <div className="bg-gradient-to-br from-orange-50 to-white rounded-3xl shadow-sm border border-orange-100 p-8 mb-6">
            <div
              className="text-lg leading-relaxed text-gray-800 [&_img]:w-full [&_img]:rounded-2xl [&_img]:mb-4 [&_p]:mb-3 [&_a]:text-blue-600 [&_a]:underline [&_b]:text-2xl"
              dangerouslySetInnerHTML={{ __html: sanitizePromoHtml(promo.content_html) }}
            />
          </div>

          <div className="bg-white rounded-3xl shadow-sm border border-gray-100 p-6">
            <h2 className="text-lg font-bold text-gray-700 mb-4">認證電話,即享優惠</h2>
            <PhoneVerification phone={user?.phone_number} onVerified={updateUser} autoStart />
          </div>
        </>
      )}
    </div>
  );
};

export default PromoPage;
